import React from 'react'
import { useSelector } from 'react-redux'
import { filterItemsByOrderStatus } from '../../utils/filter'
import { NoResults } from '../reusables/noResults'
import { LoadingScreen } from '../../loading/loading'
import { OUT_FOR_DELIVERY_FILTER } from '../../const'
import { Grid } from '@material-ui/core'
import { OrderCards } from '../orderCards/orderCards'
import { todaysDeliveriesTitleMap } from '../todaysDeliveries/todaysDeliveriesContent'

export const OutForDelivery = () => {
  const { todaysDeliveries, isLoading } = useSelector(state => state.today)
  const { language } = useSelector(state => state.auth)
  const tripsOutForDelivery = filterItemsByOrderStatus(todaysDeliveries.trips, OUT_FOR_DELIVERY_FILTER)

  return isLoading ? (
    <LoadingScreen />
  ) : (
    <Grid container alignItems="center" justify="center">
      {tripsOutForDelivery.length === 0 ? (
        <NoResults />
      ) : (
        <OrderCards data={tripsOutForDelivery} title={todaysDeliveriesTitleMap.outForDelivery[language]} orderBy={'updatedAt'} />
      )}
    </Grid>
  )
}
